import React from 'react'
import './Button.css'

export interface ButtonProps {
  variant?: 'primary' | 'secondary'
  size?: 'small' | 'medium' | 'large'
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

const Button = ({
  variant = 'primary',
  size = 'medium',
  children,
  ...props
}: ButtonProps) => (
  <button className={[
    'btn',
    `btn--${variant}`,
    `btn--${size}`
  ].join(' ')} {...props}>
    {children}
  </button>
)

export default Button